import { render, staticRenderFns } from "./MicrocartIcon.vue?vue&type=template&id=33126a57&scoped=true"
import script from "./MicrocartIcon.vue?vue&type=script&lang=js"
export * from "./MicrocartIcon.vue?vue&type=script&lang=js"
import style0 from "./MicrocartIcon.vue?vue&type=style&index=0&id=33126a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33126a57",
  null
  
)

export default component.exports